const $ = require('jquery')

const { BREAKPOINT } = require('./api')

// =========================================================================
// Module: Blog slider
// =========================================================================
const blogSlider = {
  articlesLinks () {
    const target = $('.top-offer article.teaser')

    target.on('click', function(e) {
      const _ = $(this)
      target.not(_).removeClass('prevent-trigger')
      if (window.innerWidth < BREAKPOINT.TABLET) {
        if (!_.hasClass('prevent-trigger')) {
          e.preventDefault()
          _.addClass('prevent-trigger')
        }
      }
    })
  },

  init () {
    $('.blog-slider__inner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      fade: true,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><span class="custom-icon--arr-left" aria-hidden="true"></span><span class="sr-only>Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next"><span class="custom-icon--arr-right" aria-hidden="true"></span><span class="sr-only>Next</span></button>',
      asNavFor: '.blog-slider__nav-thumbs',
      responsive: [ {
        breakpoint: BREAKPOINT.TABLET,
        settings: {
          arrows: true,
          dots: false,
          fade: true,
        },
      },
      {
        breakpoint: BREAKPOINT.TABLET,
        settings: {
          arrows: false,
          dots: true,
          fade: false,
          swipe: true,
        },
      } ],
    })

    $('.blog-slider__nav-thumbs').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.blog-slider__inner',
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true,
      responsive: [ {
        breakpoint: BREAKPOINT.DESKTOP,
        settings: {
          slidesToShow: 3,
        },
      } ],
    })

    $('.offer-link--region a').on('click', function() {
      $('.blog-slider__inner').slick('unslick')
      $('.blog-slider__nav-thumbs').slick('unslick')

      setTimeout(function() {
        $('.blog-slider__inner').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          fade: true,
          adaptiveHeight: true,
          prevArrow: '<button type="button" class="slick-prev"><span class="custom-icon--arr-left" aria-hidden="true"></span><span class="sr-only>Previous</span></button>',
          nextArrow: '<button type="button" class="slick-next"><span class="custom-icon--arr-right" aria-hidden="true"></span><span class="sr-only>Next</span></button>',
          asNavFor: '.blog-slider__nav-thumbs',
          responsive: [ {
            breakpoint: BREAKPOINT.TABLET,
            settings: {
              arrows: true,
              dots: false,
              fade: true,
            },
          },
          {
            breakpoint: BREAKPOINT.TABLET,
            settings: {
              arrows: false,
              dots: true,
              fade: false,
              swipe: true,
            },
          } ],
        })

        $('.blog-slider__nav-thumbs').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: '.blog-slider__inner',
          dots: false,
          arrows: false,
          centerMode: false,
          focusOnSelect: true,
          responsive: [ {
            breakpoint: BREAKPOINT.DESKTOP,
            settings: {
              slidesToShow: 3,
            },
          } ],
        })
      }, 0)
    })
  },
  changeDisplayMode () {
    const selButtonForCollapse = 'button.blog-slider__trigger'
    const $selItem = $('.blog-slider__item')
    const selSortDesc = 'fa fa-sort-desc'
    const _ = $('.blog-slider__inner')

    if (!_.closest('.offer-content').length) {
      if (window.innerWidth > BREAKPOINT.TABLET && !_.hasClass('slick-initialized')) {
        $('.blog-slider__inner').find(selButtonForCollapse).remove()
        $selItem.attr('style', '')
        blogSlider.init()
      } else if (window.innerWidth <= BREAKPOINT.TABLET && _.hasClass('slick-initialized')) {
        _.slick('unslick')
        $('.blog-slider__nav-thumbs').slick('unslick')

        $selItem.each(function() {
          const $this = $(this)
          const getTitle = $this.data('title')

          $(`<button class="blog-slider__trigger">${getTitle}<i class="${selSortDesc}" aria-hidden="true"></i></button>`).insertBefore($this)
        })

        $selItem.first().prev().trigger('click')
      }
    }
  },

  attachButtons () {
    const selSortDesc = 'fa fa-sort-desc'
    const selSortAsc = 'fa fa-sort-asc'

    $('.blog-slider__wrap').on('click', 'button.blog-slider__trigger', function() {
      const _ = $(this).next('.blog-slider__item')
      const icon = $(this).find('.fa')

      if (icon.attr('class') == selSortDesc) {
        icon.attr('class', selSortAsc)
      } else {
        icon.attr('class', selSortDesc)
      }

      $(this).toggleClass('active')
      _.stop(1, 0).slideToggle(250, function() {

        if ($(this).css('display') == 'none')
          $(this).css('display', '')
      })
    })
  },
}

module.exports = blogSlider



// WEBPACK FOOTER //
// ./src/modules/blogSlider.js